import { FaEdit } from "react-icons/fa";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { useState } from "react";
import OnboardOrganizationRecordModalContent from "./ModalContent/OnboardOrganizationRecordModalContent";

const OnboardingOrganisationRecordDataColumns = [
  {
    name: "Outlet type",
    selector: (row: { OutletType: string }) => row?.OutletType || "-",
    sortable: true,
    minWidth: "333px",
  },

  {
    name: "Outlet code",
    selector: (row: { OutletCode: string }) => row?.OutletCode || "-",
    sortable: true,
    minWidth: "33%",
  },

  {
    name: "Outlet name",
    selector: (row: { OutletName: string }) => row?.OutletName || "-",
    sortable: true,
    minWidth: "33%",
  },
];
const OnboardingOrganisationRecord = ({
  organizationRecordsData,
  setFilterOrgRecordsState,
}: {
  organizationRecordsData: any;
  setFilterOrgRecordsState: any;
}) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const toggleEditModal = () => setIsEditOpen(!isEditOpen);

  const handlePagination = (pageNo: number) => {
    setFilterOrgRecordsState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterOrgRecordsState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  return (
    <div>
      <BasicDataTable
        Title="Organization record"
        columns={OnboardingOrganisationRecordDataColumns}
        data={organizationRecordsData?.data?.data || []}
        search={false}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={organizationRecordsData?.data?.recordsTotal || 0}
      />
      <RouteModal
        isOpen={isEditOpen}
        toggle={toggleEditModal}
        title={"Edit Organization Record"}
        size="sm"
        content={
          <OnboardOrganizationRecordModalContent
          // handleSubmit={handleSubmit}
          // handleClose={handleClose}
          // editLeaveConfigurationModal={editLeaveConfigurationModal}
          // selectedRowData={selectedRowData}
          />
        }
      />
    </div>
  );
};

export default OnboardingOrganisationRecord;
